import '../scss/theme.scss';

// CSS libs tierces — importés ici pour que Vite bundle correctement le contenu
import '@splidejs/splide/dist/css/splide-core.min.css';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import '@fancyapps/ui/dist/carousel/carousel.css';
import '@fancyapps/ui/dist/carousel/carousel.html.css';
import '@fancyapps/ui/dist/carousel/carousel.video.css';
import '@fancyapps/ui/dist/carousel/transitions.css';

import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
import '@splidejs/splide/dist/js/splide.min';
import { Fancybox } from '@fancyapps/ui';
import Splide from '@splidejs/splide';

// Fancybox 5 — bind automatique sur tous les [data-fancybox]
Fancybox.bind('[data-fancybox]');

jQuery(document).ready(function($){

    //sticky widget

    var lastScrollTop = 0;
    var $stickyButton = $('#sticky-buttons');

    $(window).on('scroll', function() {
        var scrollTop = $(this).scrollTop();

        if (scrollTop > lastScrollTop) {
            // Scroll vers le bas - disparaitre avec effet fadeOut
            if ($stickyButton.is(':visible')) {
                $stickyButton.stop(true, true).fadeOut(300);
            }
        } else {
            // Scroll vers le haut - apparaître avec effet fadeIn
            if (!$stickyButton.is(':visible')) {
                $stickyButton.stop(true, true).fadeIn(300);
            }
        }

        lastScrollTop = scrollTop;
    });

    $('[data-open="tab"]').on('click', function(e) {
        e.preventDefault();

        $("#nav-admission-tab").trigger("click")

        $('html, body').animate({
            scrollTop: $('#nav-admission-tab').offset().top
        }, 600);
    });



    // Sticky menu & autohide on scroll
    var el_autohide = document.querySelector('.autohide');
    if (el_autohide) {
        var last_scroll_top = 0;
        window.addEventListener('scroll', function () {
            let scroll_top = window.scrollY;
            if (scroll_top === 0) {
                el_autohide.classList.remove('scrolled-up');
                el_autohide.classList.remove('scrolled-down');
            } else if (scroll_top < last_scroll_top) {
                el_autohide.classList.remove('scrolled-down');
                el_autohide.classList.add('scrolled-up');
            } else {
                el_autohide.classList.remove('scrolled-up');
                el_autohide.classList.add('scrolled-down');
            }
            last_scroll_top = scroll_top;
        });
    }

if ($('.temoignages-carousel').length) {
    $('.temoignages-carousel').each(function () {

        const splide = new Splide(this, {
            perPage: 1,
            perMove: 1,
            type: 'loop',
            arrows: true,
            pagination: false,
            updateOnMove: true,
            speed: 600,
        });

        const $wrapper = $(this).nextAll('.progress-wrapper').first();
        if (!$wrapper.length) return;

        const $bar  = $wrapper.find('.progress-bar');
        const fill  = $bar.find('.progress-fill')[0];

        if (!fill) return;

        splide.on('mounted', () => {
            const end = splide.Components.Controller.getEnd();
            const total = end + 1;
            const segmentWidth = 100 / total;
            fill.style.width = `${segmentWidth}%`;
            updateProgress();
        });

        const updateProgress = () => {
            const end = splide.Components.Controller.getEnd();
            const total = end + 1;
            const segmentWidth = 100 / total;
            const progress = splide.index * segmentWidth;
            fill.style.left = `${progress}%`;
        };

        splide.on('move', updateProgress);

        // Drag + clic sur la barre
        $bar.on('mousedown touchstart', function (e) {
            e.preventDefault();

            const move = (ev) => {
                const rect = $bar[0].getBoundingClientRect();
                const x = ev.touches ? ev.touches[0].clientX : ev.clientX;
                const percent = Math.min(Math.max((x - rect.left) / rect.width, 0), 1);

                const end = splide.Components.Controller.getEnd();
                const total = end + 1;
                const slideIndex = Math.floor(percent * total);

                splide.go(slideIndex);
            };

            const stop = () => {
                $(document).off('mousemove touchmove', move);
                $(document).off('mouseup touchend', stop);
            };

            $(document).on('mousemove touchmove', move);
            $(document).on('mouseup touchend', stop);

            move(e);
        });

        splide.mount();
    });
}

    if( $('.logos-carousel').length != 0){
        $('.logos-carousel').each(function(){
            new Splide(this, {
                    updateOnMove: true,
                    perPage: 5,
                    type: 'loop',
                    arrows: true,
                    pagination: false,
                    gap: '24px',
                    breakpoints: {
                    768: {
                        arrows: false,
                        perPage: 1,
                        padding: { left: '0px', right: '100px' },
                        gap: '1rem'
                    },
                }
                }
            ).mount();
        });
    }

    $(".dropdown-toggle").click(function(){
        window.location.href = $(this).attr("href");
    })

    $(".mobile-toggler").click(function(){
        $(".dropdown-toggle").not($(this).parent().find(".dropdown-toggle")).removeClass("show")
        $(this).parent().find(".dropdown-toggle").toggleClass("show")
    })

    $('span[data-loc]').on('click', function(e) { e.preventDefault();
        var link = atob($(this).data('loc')); $(location).attr('href',link);
    });

    // ——— Splide : Événements ——————————————————————————————————
    // Init en mobile (< 992px), destroy en desktop → 3 articles statiques flex
    var eventsSliderEl = document.getElementById('evenements-splide');

    if (eventsSliderEl) {
        var eventsSplide = null;
        var eventsBreakpoint = window.matchMedia('(min-width: 992px)');

        function initEventsSplide() {
            if (!eventsSplide) {
                eventsSplide = new Splide('#evenements-splide', {
                    type       : 'slide',
                    perPage    : 1,
                    perMove    : 1,
                    gap        : '16px',
                    padding    : { right: '15%' }, // aperçu ~15% du slide suivant
                    arrows     : false,
                    pagination : false,
                    loop       : false,
                    speed      : 400,
                    trimSpace  : false,
                });
                eventsSplide.mount();
            }
        }

        function destroyEventsSplide() {
            if (eventsSplide) {
                eventsSplide.destroy(true); // completely:true — nettoie tous les styles/attributs injectés par Splide
                eventsSplide = null;
            }
        }

        function checkEventsSplide(mq) {
            if (mq.matches) {
                destroyEventsSplide(); // Desktop : flex statique
            } else {
                initEventsSplide();    // Mobile  : slider Splide
            }
        }

        eventsBreakpoint.addEventListener('change', checkEventsSplide);
        checkEventsSplide(eventsBreakpoint);
    }

    // ——— Agenda : filtre AJAX par mois ——————————————————————————
    // La card "à la une" est fixe — seule la liste est mise à jour.
    // La pagination n'est PAS en AJAX (liens <a href> pour le SEO).
    // "Tous" redirige vers l'URL de base (rechargement complet).
    var $agendaList  = $('#agenda-list-zone');
    var $agendaChips = $('#agenda-chips');

    if ($agendaList.length && window.agendaConfig) {

        function agendaFetch(mois, annee, page) {
            $agendaList.addClass('agenda-list--loading');

            $.ajax({
                url    : window.agendaConfig.ajaxurl,
                type   : 'POST',
                data   : {
                    action      : 'agenda_filter',
                    nonce       : window.agendaConfig.nonce,
                    mois        : mois,
                    annee       : annee,
                    page        : page || 1,
                    featured_id : window.agendaConfig.featuredId || 0,
                    page_url    : window.agendaConfig.pageUrl,
                },
                success: function(res) {
                    if (res.success) {
                        $agendaList.html(res.data.list);

                        // Scroll doux vers le haut de la liste
                        $('html, body').animate({
                            scrollTop: $agendaList.offset().top - 120
                        }, 400);
                    }
                },
                complete: function() {
                    $agendaList.removeClass('agenda-list--loading');
                }
            });
        }

        function updateChips(mois, annee) {
            $agendaChips.find('.agenda-chip').each(function() {
                var $chip  = $(this);
                var cMois  = parseInt($chip.data('mois'),  10);
                var cAnnee = parseInt($chip.data('annee'), 10);
                var active = (cMois === mois && (mois === 0 || cAnnee === annee));

                $chip.toggleClass('agenda-chip--active', active);

                $chip.find('i.bi-check2').remove();
                if (active) {
                    $chip.prepend('<i class="bi bi-check2" aria-hidden="true"></i>');
                }
            });
        }

        // Chips
        $agendaChips.on('click', '.agenda-chip', function() {
            var mois  = parseInt($(this).data('mois'),  10);
            var annee = parseInt($(this).data('annee'), 10);

            updateChips(mois, annee);
            agendaFetch(mois, annee, 1);
        });
    }

    // ——— TOC : Bootstrap ScrollSpy ————————————————————————————
    if (document.querySelector('#article-toc')) {
        new bootstrap.ScrollSpy(document.body, {
            target: '#article-toc',
            smoothScroll: true,
            offset: 80,
        });
    }

    // ——— Barre de recherche Bootstrap Collapse ——
    // - Focus input à l'ouverture
    // - Injecte la hauteur du collapse dans --search-height pour pousser la navbar
    var searchCollapse = document.getElementById('search-collapse');
    var searchInput    = document.getElementById('search-collapse-input');
    if (searchCollapse) {
        searchCollapse.addEventListener('show.bs.collapse', function() {
            // Au moment de show.bs.collapse, Bootstrap n'a pas encore retiré
            // le display:none initial → scrollHeight = 0. On attend la frame
            // suivante pour que Bootstrap ait appliqué .collapsing (display:block).
            requestAnimationFrame(function() {
                var h = searchCollapse.scrollHeight;
                if (h > 0) {
                    document.body.style.setProperty('--search-height', h + 'px');
                }
            });
        });
        searchCollapse.addEventListener('shown.bs.collapse', function() {
            if (searchInput) searchInput.focus();
        });
        searchCollapse.addEventListener('hide.bs.collapse', function() {
            document.body.style.setProperty('--search-height', '0px');
        });
    }

    // ——— Menu mobile : bloquer le scroll du body quand ouvert ——
    var primaryMenu = document.getElementById('primary-menu');
    if (primaryMenu) {
        primaryMenu.addEventListener('show.bs.collapse', function() {
            document.body.classList.add('overflow-hidden');
        });
        primaryMenu.addEventListener('hide.bs.collapse', function() {
            document.body.classList.remove('overflow-hidden');
        });
    }

    // ——— Skin-ad desktop : clic dans les marges du wallpaper ——————————————
    // data-pub-url est posé sur <body> par header.php (desktop uniquement).
    // Clic en dehors du .container → ouvre l'URL dans un nouvel onglet.
    (function() {
        var pubUrl = document.body.getAttribute('data-pub-url');
        if (!pubUrl) return;

        function openPub() {
            window.open(pubUrl, '_blank', 'noopener,noreferrer');
        }

        document.addEventListener('click', function(e) {
            // Ignorer les clics sur des éléments interactifs
            if (e.target.closest('a, button, input, select, textarea, label, [role="button"]')) return;
            // Détecter si le clic est dans les marges (hors container)
            var container = document.querySelector('main .container')
                         || document.querySelector('.container');
            if (!container) return;
            var rect = container.getBoundingClientRect();
            if (e.clientX < rect.left || e.clientX > rect.right) {
                openPub();
            }
        });
    })();

})